<template>
  <div class="theoryexam">
      <el-header style="height:40px;">
      <el-page-header @back="goBack" content="答案详情">
      </el-page-header>
    </el-header>
    <div class="testname">得分:{{allsocre}}</div>
    <!-- 单选题 -->
    <div class="singlechoice">
      <div class="questiontype">单选题<span>(共{{Singlechoice.length}}题,得分：{{Singlechoicesocre}})</span></div>
      <ul>
        <li v-for="(item,index) in Singlechoice" class="question">
          <div class="title">
            {{index+1}}、{{item.test_content.question}}
            <span>({{item.test_content.poins}}分)</span>
          </div>
          <template v-if="item.test_content.content1.length>0">
            <div class="questionsitem" v-for="(items,index1) in item.test_content.content1" :class="{'active':items.select==true}" :key="index1" @click="goSingle(item,items)">
              <i class="el-icon-success"></i>{{items.name}}
            </div>
          </template>
          <div class="answers">标准答案：{{item.test_content.answer}} <span class="answericon">作答： <i :class='{"el-icon-check":item.isright==1,"el-icon-close":item.isright==2}'></i></span> </div>
        </li>
      </ul>
    </div>
    <!-- 多选题 -->
    <div class="singlechoice">
      <div class="questiontype">多选题<span>(共{{checkboxchoice.length}}题)</span></div>
      <ul>
        <li v-for="(item,index) in checkboxchoice" class="question">
          <div class="title">
            {{index+1}}、{{item.test_content.question}}
            <span>({{item.test_content.poins}}分)</span>
          </div>
          <template v-if="item.test_content.content1.length>0">
            <div class="questionsitem" v-for="(items,index1) in item.test_content.content1" :class="{'active':items.select==true}" :key="index1" @click="gocheckbox(item,items)">
              <i class="el-icon-success"></i>{{items.name}}
            </div>
          </template>
          <div class="answers">标准答案：{{item.test_content.answer1}}</div>

        </li>
      </ul>
    </div>
    <!--判断题  -->
    <div class="singlechoice">
      <div class="questiontype">判断题<span>(共{{decide.length}}题)</span></div>
      <ul>
        <li v-for="(item,index) in decide" class="question">
          <div class="title">
            {{index+1}}、{{item.test_content.question}}
            <span>({{item.test_content.poins}}分)</span>
          </div>
          <template v-if="item.test_content.content1.length>0">
            <div class="questionsitem" v-for="(items,index1) in item.test_content.content1" :class="{'active':items.select==true}" :key="index1" @click="godecide(item,items)">
              <i class="el-icon-success"></i>{{items.name}}
            </div>
          </template>
          <div class="answers">标准答案：{{item.test_content.answer}}</div>
        </li>
      </ul>
    </div>
    <!--填空题  -->
    <div class="singlechoice">
      <div class="questiontype">填空题<span>(共{{fill.length}}题)</span></div>
      <ul>
        <li v-for="(item,index) in fill" class="question">
          <div class="title">
            {{index+1}}、{{item.test_content.question}}
            <span>({{item.test_content.poins}}分)</span>
          </div>
          <div class="answer">
            <div>答案:</div>
            <el-input type="textarea" :rows="2" placeholder="答案之间请用空格隔开" v-model="item.answer">
            </el-input>
          </div>
          <div class="answers">标准答案：{{item.test_content.answer}}</div>
        </li>
      </ul>
    </div>
    <!--名词解释题  -->
    <div class="singlechoice">
      <div class="questiontype">名词解释题<span>(共{{definitions.length}}题)</span></div>
      <ul>
        <li v-for="(item,index) in definitions" class="question">
          <div class="title">
            {{index+1}}、{{item.test_content.question}}
            <span>({{item.test_content.poins}}分)</span>
          </div>
          <div class="answer">
            <div>答案:</div>
            <el-input type="textarea" :rows="2" placeholder="请输入答案" v-model="item.answer">
            </el-input>
          </div>
          <div class="answers">标准答案：{{item.test_content.answer}}</div>
        </li>
      </ul>
    </div>
    <!--论述题  -->
    <div class="singlechoice">
      <div class="questiontype">论述题<span>(共{{discuss.length}}题)</span></div>
      <ul>
        <li v-for="(item,index) in discuss" class="question">
          <div class="title">
            {{index+1}}、{{item.test_content.question}}
            <span>({{item.test_content.poins}}分)</span>
          </div>
          <div class="answer">
            <div>答案:</div>
            <el-input type="textarea" :rows="2" placeholder="请输入答案" v-model="item.answer">
            </el-input>
          </div>
          <div class="answers">标准答案：{{item.test_content.answer}}</div>
        </li>
      </ul>
    </div>
    <!--简答题  -->
    <div class="singlechoice">
      <div class="questiontype">简答题<span>(共{{shortanswer.length}}题)</span></div>
      <ul>
        <li v-for="(item,index) in shortanswer" class="question">
          <div class="title">
            {{index+1}}、{{item.test_content.question}}
            <span>({{item.test_content.poins}}分)</span>
          </div>
          <div class="answer">
            <div>答案:</div>
            <el-input type="textarea" :rows="2" placeholder="请输入答案" v-model="item.answer">
            </el-input>
          </div>
          <div class="answers">标准答案：{{item.test_content.answer}}</div>
        </li>
      </ul>
    </div>
    <el-button class="" @click="submitbtn()">提交</el-button>
  </div>
</template>

<script>
export default {
  props: {

  },
  data() {
    return {
      Singlechoice: [],//1单选
      checkboxchoice: [],//2多选
      decide: [],//3判断
      fill: [],//4填空题
      definitions: [],//5名词解释题
      discuss: [],//6：论述题
      shortanswer: [],//7：简答题
      zmlist: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'],
      answer: [],
      id: [],
      testid: '',
      typelist: [],
      info: {},
      Singlechoicesocre: 0,
      checkboxchoicesocre: 0,
      decidesocre: 0,
      fillsocre: 0,
      definitionssocre: 0,
      discusssocre: 0,
      shortanswersocre: 0,
      allsocre: 0,
    };
  },
  computed: {

  },
  created() {
    this.itestid = this.$route.query.testid
    this.getdetails(this.itestid);
  },
  methods: {
    //type 1:单选题 2：多选题 3：判断题 4：填空题 5名词解释题 6：论述题 7：简单题
    getdetails(id) {
      this.$http.records(id)
        .then(res => {

          if (res.data.length > 0) {
            var question = res.data

            var Singlechoice = []
            var checkboxchoice = []
            var decide = []
            var fill = []
            var definitions = []
            var discuss = []
            var shortanswer = []
            var Singlechoicesocre = 0
            var checkboxchoicesocre = 0
            var decidesocre = 0
            var fillsocre = 0
            var definitionssocre = 0
            var discusssocre = 0
            var shortanswersocre = 0
            var allsocre = 0

            question.forEach(val => {
              allsocre = allsocre + val.poins
              if (val.type == 1) {
                Singlechoicesocre = Singlechoicesocre + val.poins;
                val.test_content.content = val.test_content.content.replace(/\s/g, "").split(/[a-z|A-Z]\./g)
                val.test_content.content = val.test_content.content.slice(1, val.test_content.content.length)
                var arr = []
                val.test_content.content.forEach((ele, i) => {
                  //   if(val.answer==)
                  var obj = {
                    name: this.zmlist[i] + '.' + ele,
                    select: val.answer == this.zmlist[i] ? true : false
                  }
                  arr.push(obj)
                })
                val.test_content.content1 = arr
                Singlechoice.push(val)


                //   console.log(Singlechoice)
              }
              else if (val.type == 2) {
                checkboxchoicesocre = checkboxchoicesocre + val.poins;
                val.test_content.content = val.test_content.content.replace(/\s/g, "").split(/[a-z|A-Z]\./g)
                val.test_content.content = val.test_content.content.slice(1, val.test_content.content.length)

                if (val.answer) {
                  val.answer = val.answer.split(" ")
                }
                // console.log(val.answer)
                var arr = []
                val.test_content.content.forEach((ele, j) => {
                  var obj = {
                    name: this.zmlist[j] + '.' + ele,
                    select: false
                  }
                  if (val.answer && val.answer.length > 0) {
                    if (val.answer.indexOf(this.zmlist[j]) > -1) {
                      obj.select = true;
                    }
                  }
                  arr.push(obj)
                })
                val.test_content.content1 = arr
                val.test_content.answer1 = val.test_content.answer.replace(/\s/g, "")
                checkboxchoice.push(val)
              }
              else if (val.type == 3) {
                decidesocre = decidesocre + val.poins;
                val.test_content.content1 = [
                  {
                    name: "正确",
                    select: val.answer == "正确" ? true : false
                  },
                  {
                    name: "错误",
                    select: val.answer == "错误" ? true : false
                  },
                ]
                decide.push(val)
              }
              else if (val.type == 4) {
                fillsocre = fillsocre + val.poins;
                fill.push(val)

              } else if (val.type == 5) {
                definitionssocre = definitionssocre + val.poins;
                definitions.push(val)
              } else if (val.type == 6) {
                discusssocre = discusssocre + val.poins;
                discuss.push(val)
              } else {
                shortanswersocre = shortanswersocre + val.poins;
                shortanswer.push(val)
              }
            })
            this.Singlechoice = Singlechoice
            this.checkboxchoice = checkboxchoice
            this.decide = decide
            this.fill = fill
            this.definitions = definitions
            this.discuss = discuss
            this.shortanswer = shortanswer
            this.Singlechoicesocre = Singlechoicesocre
            this.checkboxchoicesocre = checkboxchoicesocre
            this.decidesocre = decidesocre
            this.fillsocre = fillsocre
            this.definitionssocre = definitionssocre
            this.discusssocre = discusssocre
            this.shortanswersocre = shortanswersocre
            this.allsocre = allsocre
          }

        })
    },
    goSingle(item, items) {
      item.content1.forEach(element => {
        element.select = false;
      });
      items.select = true;
      // console.log(this.Singlechoice)
    },
    gocheckbox(item, items) {

      items.select = !items.select;
    },
    godecide(item, items) {
      items.select = !items.select;
    },
    submitbtn() {
      //  this.Singlechoice = Singlechoice
      //               this.checkboxchoice = checkboxchoice
      //               this.decide = decide
      //               this.fill = fill
      //               this.definitions = definitions
      //               this.discuss = discuss
      //               this.shortanswer = shortanswer
      var arr1 = new Array(this.Singlechoice.length).fill('');
      var arr2 = new Array(this.checkboxchoice.length).fill('');
      var arr3 = new Array(this.decide.length).fill('');
      var arr4 = new Array(this.fill.length).fill('');
      var arr5 = new Array(this.definitions.length).fill('');
      var arr6 = new Array(this.discuss.length).fill('');
      var arr7 = new Array(this.shortanswer.length).fill('');
      //1单选题

      for (var i = 0; i < this.Singlechoice.length; i++) {
        for (var j = 0; j < this.Singlechoice[i].content1.length; j++) {
          if (this.Singlechoice[i].content1[j].select) {

            // arr1.push(this.Singlechoice[i].content1[j].name.split('.')[0])
            arr1.splice(i, 1, this.Singlechoice[i].content1[j].name.split('.')[0])
          }
        }
      }
      //console.log(arr1)

      //2多选题
      for (var i = 0; i < this.checkboxchoice.length; i++) {
        var str = [];
        for (var j = 0; j < this.checkboxchoice[i].content1.length; j++) {

          if (this.checkboxchoice[i].content1[j].select) {
            //=str+this.checkboxchoice[i].content1[j].name.split('.')[0]
            str.push(this.checkboxchoice[i].content1[j].name.split('.')[0])
            //arr.push(this.checkboxchoice[i].content1[j].select.name)
          }
        }
        // console.log(str)
        // arr2.push(str.json(' '))
        arr2.splice(i, 1, str.join(' '))
      }
      //  console.log(arr2)
      //    return;
      //3：判断题
      for (var i = 0; i < this.decide.length; i++) {
        for (var j = 0; j < this.decide[i].content1.length; j++) {

          if (this.decide[i].content1[j].select) {
            arr3.splice(i, 1, this.decide[i].content1[j].name)
          }
        }

      }
      // console.log(arr3)
      //4填空题
      for (var i = 0; i < this.fill.length; i++) {
        // arr4.push(this.fill[i].content1)
        arr4.splice(i, 1, this.fill[i].content1)
      }
      //console.log(arr4)
      //5名词解释题
      for (var i = 0; i < this.definitions.length; i++) {
        //arr5.push(this.definitions[i].content1)
        arr5.splice(i, 1, this.definitions[i].content1)
      }
      //6：论述题
      for (var i = 0; i < this.discuss.length; i++) {
        // arr6.push(this.discuss[i].content1)
        arr6.splice(i, 1, this.discuss[i].content1)
      }
      //7：简答题
      for (var i = 0; i < this.shortanswer.length; i++) {
        //arr7.push(this.shortanswer[i].content1)
        arr7.splice(i, 1, this.shortanswer[i].content1)
      }
      var arrall = [...arr1, ...arr2, ...arr3, ...arr4, ...arr5, ...arr6, ...arr7]
      // console.log(arrall)
      // return;
      this.$confirm('提交前请检查试卷是否全部完成,是否提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        var params = {
          logid: this.testid,
          cid: this.id,
          answer: arrall,
          type: this.typelist
        }
        this.$http.theorysubmit(params)
          .then(res => {
            if (res.code == 200) {
              this.$alert('提交成功', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  this.$router.back()

                }

              });

            } else {
              this.$message.error(res.message)
            }
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });

    },
    goBack() {
      this.$router.back()
    },

  },
};
</script>

<style  lang="less">
.theoryexam {
  .testname {
    text-align: center;
    font-size: 18px;
    color: #333333;
    font-weight: bold;
    margin-bottom: 10px;
    span {
      font-size: 14px;
      font-weight: normal;
    }
  }
  .singlechoice {
    .questiontype {
      font-size: 18px;
      color: #333333;
      margin-bottom: 10px;
      font-weight: bold;
      span {
        font-weight: normal;
        font-size: 14px;
      }
    }
    ul {
      li {
        list-style: none;
        margin-bottom: 20px;
        .title {
          font-size: 16px;
          color: #333333;
          //   font-weight: bold;
          margin-bottom: 10px;
          span {
            font-size: 14px;
          }
        }
        .questionsitem {
          color: #333333;
          font-size: 15px;
          padding: 10px 0;
          text-indent: 2em;
          position: relative;
          .el-icon-success {
            color: #ccc;
            font-size: 20px;
            //  position: absolute;
            top: 0;
            left: 0;
          }
        }
        .active {
          color: #409eff;
          .el-icon-success {
            color: #409eff;
          }
        }
        .answer {
          div {
            margin-bottom: 10px;
          }
        }
        .answers {
          color: #409eff;
          //font-weight: bold;
          font-size: 16px;
          .answericon {
            margin-left: 20px;
            .el-icon-check {
              color: #67c23a;
              font-size: 24px;
              font-weight: bold;
            }
            .el-icon-close {
              color: #f56c6c;
              font-size: 24px;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/assessment/answerlist.vue